// 자동차 메인 외 추가 서비스 콘텐츠 (현재 오토바이 1종).
// 자동차 메인 6개는 serviceContent.js MAIN_CONTENT.

export const SERVICE_CONTENT_EXTRA = {
  // 오토바이 — 외부세차 (단독, 차종별 추가 메뉴는 상의)
  'basic-wash': {
    title: '수원 오토바이 외부세차 — KOA DETAILING (5만원)',
    description: '수원 곡반정 KOA DETAILING 오토바이 외부세차. 고온 스팀 외부 세척으로 벌레자국·체인오일·도로 분진까지 5만원. 광택·디테일링은 차종별 상의.',
    h1: '오토바이 외부세차',
    subtitle: '고온 스팀 외부 세척 — 벌레자국·체인오일·잔 오염 정리',
    keywords: ['수원 오토바이 세차', '곡반정 바이크 세차', '오토바이 손세차', '스쿠터 세차', '바이크 디테일링'],
    intro: '오토바이 전용 외부세차 메뉴입니다. 고온 스팀으로 벌레자국·체인오일·도로 분진까지 분리한 뒤 손세척으로 마무리합니다. 도장면 흠집 없이 깔끔하게 정리됩니다.',
    benefits: [
      '고온 스팀 비접촉 세정 — 도장·플라스틱 외장 흠집 없음',
      '벌레자국·체인오일·도로 분진 깊은 곳까지 처리',
      '125cc 미만부터 1000cc 초과까지 동일 5만원',
    ],
    bestFor: '출퇴근·배달·투어링 바이크, 정기 관리 받고 싶은 라이더.',
    duration: '30~45분',
    process: [
      '바이크 외부 사전 점검',
      '고온 스팀으로 벌레자국·기름때 1차 분리',
      '친환경 약품 거품 도포 + 손세척',
      '체인·휠 영역 집중 처리',
      '미세섬유 타월 마감',
    ],
    faqs: [
      {
        q: '광택·코팅도 가능한가요?',
        a: '오토바이 광택·코팅·디테일링은 차종(배기량·도장 상태)별로 작업 시간과 가격이 크게 다릅니다. 매장 또는 전화(010-3931-4528)로 견적 상담드립니다.',
      },
      {
        q: '배기량별 가격이 다른가요?',
        a: '오토바이 외부세차는 125cc 미만부터 1000cc 초과까지 일괄 5만원입니다. 광택·디테일링 등 추가 작업은 차종별 견적입니다.',
      },
      {
        q: '얼마나 자주 받으면 좋나요?',
        a: '출퇴근·배달 바이크는 2주에 1회, 투어링 후엔 즉시 권장. 체인·도장 보호에 큰 도움이 됩니다.',
      },
    ],
    relatedServices: ['premium-polish', 'hydro-coating', 'glass-coating-ceramic'],
  },
};
